const invertedMessages = {
  'Click to open side panel': 'certs.click.open.side.panel',
};

export default invertedMessages;
